$(function(){
    if ($('.product-detail-read-more').length > 0){
        $('.product-detail-read-more').appendTo($('#product-detail-tekst-tekst p:last'));
    }
    $('.order-stickers-select-product').click(function(){
        var productId = $(this).attr('data-id');
        orderStickers.selectProduct(productId);
        return false;
    });
    orderStickers.init();
});

var orderStickers = {
    urls: [],
    formaat0: 0,
    formaat1: 0,
    formaat2: null,
    formOptions: {},
    priceAmount: 0,
    priceShipping: 0,
    priceTotal: 0,
    deliveryType: null,
    productId: null,
    formatSquareCm: null,

    selectProduct: function(productId){
        orderStickers.productId = productId;
        $('.cat-item-active').removeClass('cat-item-active');
        $('.cat-item-inner[data-id="' + productId + '"]').closest('.cat-item').addClass('cat-item-active');
        $.fancybox.showLoading();
        $.ajax({
            type: 'post',
            data: {'do' : 'showComponent', 'module' : 'producten', 'args[naam]' : 'ProductInner', 'productId' : productId},
            success: function(data){
                $('#product-content').html(data);
                $('#responsiveTabsDemo #tab-1').show();
                if ($('#responsiveTabsDemo .gen-left').length > 0){
                    orderStickers.init();
                } else {
                    requestOffer.init();
                }
                $('html, body').animate({
                    // scrollTop: $("#responsiveTabsDemo").offset().top - 30
                    scrollTop: $(".cat-item-active").offset().top - 30
                }, 350);
                $.fancybox.hideLoading();
            }
        })
    },
    viewAllFormats: function(){
        $('.hidden-materiaal').fadeIn(500);
        $('.gen-more-items').hide();
    },
    goToNextStep: function(element){

        // text right sidebar
        var nr = parseInt(element.closest('.parent-wrapper').attr('data-nr'));
        console.log('nr', nr);
        if (!element.hasClass('gen-item-eigen') && typeof(nr) !== "undefined"){
            var sidebar = $('.sidebar-item' + nr);
            if (element.find('.oplage-aantal') && element.find('.oplage-aantal').length > 0) {
                var oplage = $(':input[name="oplage-group"]:checked').val();
                sidebar.find('.sidebar-item-text').text(oplage);
            } else if (nr == 2){
                var text = element.find('.gen-item-title').text() + ' '  + element.find('.gen-item-subtitle').text();
                var belijming = $(':input[name="belijming"]:checked');
                if (belijming.length > 0){
                    text += ' ' + belijming.next('label').html();
                }
                sidebar.find('.sidebar-item-text').text(text);
            } else {
                var text = element.find('.gen-item-title').text() + ' '  + element.find('.gen-item-subtitle').text();
                sidebar.find('.sidebar-item-text').text(text);
            }
        }
        $(".sidebar-item" + nr).addClass('sidebar-item-active');

        // activate next block
        var nextNr = (nr + 1);
        $('.gen-block-active').removeClass('gen-block-active');
        $(".gen-block-" + nextNr).addClass('gen-block-active');
        var genClass = '.gen-block-' + nextNr;
        $(genClass).find('.gen-content').show();

        // scroll to next
        $('html, body').animate({
            scrollTop: $(genClass).offset().top -30
        }, 550, function(){

        });

        console.log('element', element);
        // set formaat
        if (typeof(element.attr('data-formaat-0')) !== 'undefined'){
            orderStickers.formaat0 = element.attr('data-formaat-0');
            orderStickers.formaat1 = element.attr('data-formaat-1');
            orderStickers.formaat2 = element.attr('data-formaat-2');
            orderStickers.formatSquareCm = parseFloat(orderStickers.formaat0) * parseFloat(orderStickers.formaat1) / 100;
            orderStickers.hideShowSnijdenOpMaat();
        }

        // prices
        orderStickers.setFormOptions(orderStickers.allStepsDone);
    },

    virtualPageview: function(done){

        setTimeout(function(){

            var name = $('#content-sub-product-bottom').attr('data-product-name');
            var url = '/' + $('#content-sub-product-bottom').attr('data-product-url') + '/';
            if (orderStickers.formOptions.formaat0 && orderStickers.formOptions.formaat1){
                url += '?formaat=' + orderStickers.formOptions.formaat0 + 'x' + orderStickers.formOptions.formaat1;
            }
            if (orderStickers.formOptions.materiaalId){
                url += '&materiaal=' + orderStickers.formOptions.materiaalId;
            }
            if (orderStickers.formOptions.belijmingId){
                url += '&belijmingId=' + orderStickers.formOptions.belijmingId;
            }
            if (orderStickers.formOptions.bedrukkingId){
                url += '&bedrukking=' + orderStickers.formOptions.bedrukkingId;
            }
            if (orderStickers.formOptions.afwerkingId){
                url += '&afwerkingId=' + orderStickers.formOptions.afwerkingId;
            }
            if (orderStickers.formOptions.oplage){
                url += '&oplage=' + orderStickers.formOptions.oplage;
            }
            if (orderStickers.deliveryType){
                url += '&deliveryType=' + orderStickers.deliveryType;
            }
            if (done){
                url += '&toevoegenAanWinkelwagen=1';
            }
            if (orderStickers.urls.indexOf(url) === -1){
                orderStickers.urls.push(url);
                if (typeof(dataLayer) !== "undefined" && dataLayer){
                    dataLayer.push({
                        'event':'VirtualPageview',
                        'virtualPageURL':url,
                        'virtualPageTitle' : name
                    });
                    console.log('datalayer push', url, name);
                }
            }
        }, 200);
    },

    allStepsDone: function(){

        var formaat0 = orderStickers.formaat0;
        var formaat1 = orderStickers.formaat1;
        var productId = orderStickers.productId;
        var materiaalId = $('.parent-wrapper[data-nr="2"]').children('.gen-active').attr('data-subtext-id');
        var belijmingId = $(':input[name="belijming"]:checked').val();
        var bedrukkingId = $('.parent-wrapper[data-nr="3"]').children('.gen-active').attr('data-subtext-id');
        var afwerkingId = $('.parent-wrapper[data-nr="4"]').children('.gen-active').attr('data-subtext-id');

        if (
             (typeof(formaat0) !== "undefined" && formaat0.length > 0)
            && (typeof(formaat1) !== "undefined" && formaat1.length > 0)
            && (typeof(productId) !== "undefined" && productId.length > 0)
            && (typeof(materiaalId) !== "undefined" && materiaalId.length > 0)
            && ((typeof(belijmingId) !== "undefined" && belijmingId.length > 0) || $(':input[name="belijming"]').length === 0)
            && ((typeof(bedrukkingId) !== "undefined" && bedrukkingId.length > 0) || $('.parent-wrapper[data-nr="3"]').length === 0)
            && ((typeof(afwerkingId) !== "undefined" && afwerkingId.length > 0) || $('.parent-wrapper[data-nr="4"]').length === 0)
        ){
            orderStickers.setFormOptions(orderStickers.setPrices);
            return true;
        }
        return false;

    },
    showHideShape: function() {
        $('.hidden-materiaal').show();
        $('.gen-more-items').hide();
        var shape = $(':input[name="vorm"] option:selected').attr('data-type');
        if (shape == 'alle'){
            $('.gen-format-wrapper').show();
        } else {
            $('.gen-format-wrapper').hide();
            $('.gen-format-wrapper[data-type="' + shape + '"]').show();
        }
    },
    setPrices: function(callback){
        $.fancybox.showLoading();
        $('.oplage-label').addClass('oplage-label-disabled');
        $.ajax({
            type: 'post',
            dataType: 'json',
            url: 'producten/stickers-bestellen/',
            data: {formOptions: JSON.stringify(orderStickers.formOptions), action: 'GetPrijzen'},
            success: function(prices){
                $('.oplage-label').removeClass('oplage-label-disabled');
                $.fancybox.hideLoading();
                for (var oplage in prices){
                    if (prices.hasOwnProperty(oplage)) {
                        var price;
                        var elem = $(':input[name="oplage-group"][value="' + oplage + '"]');
                        if (oplage == 'custom' && $('.oplage-custom-input').val().length === 0) {
                            elem.attr('data-price', 0);
                            elem.closest('.oplage-label').find('.oplage-price').html('');
                        } else if (oplage == 'custom'){
                            var customOplage = parseInt($('.oplage-custom-input').val());
                            price = parseFloat(prices[customOplage]);
                            elem.attr('data-price', price);
                            elem.closest('.oplage-label').find('.oplage-price').html('&euro; ' + number_format((price / 100), 2, ',', '.'));
                            elem.val(customOplage);
                        } else {
                            price = parseFloat(prices[oplage]);
                            elem.attr('data-price', price);
                            elem.closest('.oplage-label').find('.oplage-price').html('&euro; ' + number_format((price / 100), 2, ',', '.'));
                        }
                    }
                }
                if (typeof callback === 'function'){
                    callback();
                }
            }
        });
    },
    setOplages: function(){
        var oplages = [];
        $('input[name="oplage-group"]').each(function(){
            oplages.push($(this).val())
        });
        if ($('.oplage-custom-input').val().length > 0){
            oplages.push($('.oplage-custom-input').val());
        }
        orderStickers.formOptions.oplages = oplages;
        return oplages;
    },
    setFormOptions: function(callback, done){

        done = typeof(done) === "undefined" ? false : done;

        setTimeout(function(){
            var formaat0 = orderStickers.formaat0;
            var formaat1 = orderStickers.formaat1;
            var formaat2 = orderStickers.formaat2;
            var productId = orderStickers.productId;
            var materiaalId = $('.parent-wrapper[data-nr="2"]').children('.gen-active').attr('data-subtext-id');
            var belijmingId = $(':input[name="belijming"]:checked').val();
            var bedrukkingId = $('.parent-wrapper[data-nr="3"]').children('.gen-active').attr('data-subtext-id');
            var afwerkingId = $('.parent-wrapper[data-nr="4"]').children('.gen-active').attr('data-subtext-id');

            var levertijd = $('.del-block-active').length > 0 ? $('.del-block-active').attr('data-days') : null;


            var oplages = orderStickers.setOplages();

            orderStickers.formOptions = {
                formaat0: formaat0,
                formaat1: formaat1,
                formaat2: formaat2,
                materiaalId: materiaalId,
                belijmingId: belijmingId,
                bedrukkingId: bedrukkingId,
                afwerkingId: afwerkingId,
                oplages: oplages,
                productId: productId,
                deliveryType: orderStickers.deliveryType,
                oplage: $(':input[name="oplage-group"]:checked').length > 0 ? $(':input[name="oplage-group"]:checked').val() : 0,
            };
            if (typeof callback === 'function'){
                callback();
            }
            orderStickers.virtualPageview(done);
        }, 100)
    },
    addToShoppingCart:function(){
        $.fancybox.showLoading();
        $.ajax({
            url: 'producten/stickers-bestellen/',
            type: 'post',
            data: {action: 'AddToWinkelwagen', formOptions: JSON.stringify(orderStickers.formOptions)},
            dataType: 'json',
            success: function(data){
                if (data.success){
                    $.fancybox('<h1>Toevoegen winkelwagen</h1><p>Het product is succesvol toegevoegd aan de winkelwagen</p><span class="fancy-btn"><a href="webshop/winkelwagen/2/" class="standaard-button">Naar de winkelwagen</a><span class="of-keuze">of</span><a class="verder-winkelen" href="#" onclick="$.fancybox.close(); return false;">verder winkelen</a></span>');
                    $.fancybox.hideLoading();
                    updateWinkelwagenTop();
                } else {
                    $.fancybox('<h1>Toevoegen winkelwagen</h1><p>Er is een fout opgetreden, probeer het opnieuw of raadpleeg onze klantenservice</p>');
                }
            }
        })
    },
    hideShowSnijdenOpMaat: function(){
        var span = $('.gen-block-4 span.gen-item-title:contains("Snijden op maat")');
        if (span.length > 0){
            var genItem = span.closest('.gen-item');
            if (parseFloat(orderStickers.formaat0) < 35 || parseFloat(orderStickers.formaat1) < 35){
                genItem.hide();
            } else {
                genItem.show();
            }
        }
    },
    checkEigenFormaat: function(){
        if (t !== null){
            clearTimeout(t);
        }
        t = setTimeout(function(){
            t = null;
            if ($(':input[name="eigen_formaat[0]"]').val().length > 0 && $(':input[name="eigen_formaat[1]"]').val().length > 0){
                $(".sidebar-item1").addClass('sidebar-item-active');

                orderStickers.formaat0 = $(':input[name="eigen_formaat[0]"]').val();
                orderStickers.formaat1 = $(':input[name="eigen_formaat[1]"]').val();
                orderStickers.formaat2 = $(':input[name="eigen_formaat[2]"]').val();
                orderStickers.formatSquareCm = parseFloat(orderStickers.formaat0) * parseFloat(orderStickers.formaat1) / 100;
                orderStickers.hideShowSnijdenOpMaat();

                $('.sidebar-item1').find('.sidebar-item-text').text(orderStickers.formaat0 + ' x ' + orderStickers.formaat1 + ' mm' + ' ' + orderStickers.formaat2);

                setTimeout(function(){
                    if ($(':input[name="eigen_formaat[0]"]').val().length > 0 && $(':input[name="eigen_formaat[1]"]').val().length > 0){
                        orderStickers.goToNextStep($('.gen-item-eigen'));
                    }
                }, 1000);
            } else {
                $(".sidebar-item1").removeClass('sidebar-item-active');
                $('.sidebar-item1').find('.sidebar-item-text').text('< kies uw formaat');
            }
        }, 400)
    },
    setPrice: function(price){
        console.log('price', price);
        price = parseFloat(price);
        orderStickers.priceAmount = price;
        price = price / 100;
        $('.del-block').each(function(){
            var extraCosts = parseFloat($(this).attr('data-price'));
            var total = price + extraCosts;
            $(this).find('.del-block-price').html('&euro; ' + number_format(total, 2, ',', '.' ));
        });

        /*
        var costsSpeedDelivery = 10;
        var costsSuperSpeedDelivery = 25;
        $('.del-block[data-levering="normaal"]').find('.del-block-price').html('&euro; ' + number_format(price, 2, ',', '.' ));
        $('.del-block[data-levering="spoed"]').find('.del-block-price').html('&euro; ' + number_format(price+costsSpeedDelivery, 2, ',', '.' ));
        $('.del-block[data-levering="superspoed"]').find('.del-block-price').html('&euro; ' + number_format(price+costsSuperSpeedDelivery, 2, ',', '.' ));
        */

    },
    setPriceCustom: function(){
        console.log('ik kom hier');
        console.log($('#oplage_right_custom').attr('data-price'));
        if ($('#oplage_right_custom').is(':checked')){
            orderStickers.setPrice($('#oplage_right_custom').attr('data-price'));
            var elem = $('.oplage-label:first');
            orderStickers.goToNextStep(elem);
        }
    },
    init: function(){

        $('.sidebar-add-inner').click(function(){
            if ($(this).hasClass('sidebar-add-active')){
                orderStickers.setFormOptions(orderStickers.addToShoppingCart, true);
            }
            return false;
        });



        if($('#responsiveTabsDemo .tabs-product').length > 0){
            $('#responsiveTabsDemo').responsiveTabs({
                startCollapsed: 'accordion'
            });
            if ($('.tab-3-link').length > 0){
                $('.tab-3-link').click();
            }
        }

        if ($('.content, .sidebar').length > 0){
            $('.content, .sidebar').theiaStickySidebar({
                additionalMarginTop: 30
            });
        }

        // text right sidebar and scroll to next
        $('.gen-block .gen-item').on('click', function(){
            var nr = $(this).closest('.parent-wrapper').attr('data-nr');
            if (parseInt(nr) == 2){
                if ($(':input[name="belijming"]').length == 0 || $(':input[name="belijming"]:checked').length > 0){
                    orderStickers.goToNextStep($(this));
                }
            } else {
                if (!$(this).hasClass('gen-item-eigen') && $(this).attr('id') !== "oplage_right_custom"){
                    orderStickers.goToNextStep($(this));
                }
            }
        });

        $('.gen-block :input[name="oplage-group"]').change(function(){
            if ($(this).attr('id') !== "oplage_right_custom"){
                var elem = $('.oplage-label:first');
                orderStickers.goToNextStep(elem);
                orderStickers.setPrice($(this).attr('data-price'));
            }
        });

        $('.oplage-custom-input').focus(function(){
            if (!$('#oplage_right_custom').is(':checked')){
                $('.oplage-custom label').click();
                $('.oplage-custom-input').focus();
            }
        });
        $('.oplage-custom-input').change(function(){
            var oplage = parseInt($(this).val());
            if (oplage > 0){
                orderStickers.setOplages();
                orderStickers.setPrices(orderStickers.setPriceCustom);
            }
        });

        $('.oplage-label').click(function(){
            if ($(this).hasClass('oplage-label-disabled')){
                return false;
            }
        });

        $(':input[name="belijming"]').change(function(){
            if ($('.parent-wrapper[data-nr="2"] .gen-active').length > 0){
                var elem = $('.parent-wrapper[data-nr="2"] .gen-active');
                orderStickers.goToNextStep(elem);
            }
        });

        for (var i=1; i < 6; i++){
            $(".sidebar-item" + i).click(function() {
                $('html, body').animate({
                    scrollTop: $(".gen-block-" + i).offset().top - 30
                }, 1000);
            });
        }

        $(':input[name="vorm"]').change(function(){
            orderStickers.showHideShape();
        });

        // show / hide option text
        $(".subtext-parent").hover(function(){
            var parent = $(this).parents('.subtext-wrapper:first');
            var id = $(this).attr('data-subtext-id');
            parent.find('.subtext-content').hide();
            parent.find('.subtext-content[data-subtext-id="' + id + '"]').show();
        }, function(){
            var parent = $(this).parents('.subtext-wrapper:first');
            var active = parent.find('.gen-active');
            if (active.length > 0){
                var id = active.attr('data-subtext-id');
                parent.find('.subtext-content').show();
                parent.find('.subtext-content[data-subtext-id!="' + id + '"]').hide();
            }
        });

        $(".gen-block-1 .gen-item-list .gen-item-eigen").click(function() {
            $(".gen-block-1").addClass('gen-block-active');
        });

        $(".gen-item-list[data-nr='2']").click(function(){
            $('html, body').animate({
                scrollTop: $(".gem-plak-main-title").offset().top - 30
            }, 500);
        });

        $(':input[name="eigen_formaat[0]"]').keyup(orderStickers.checkEigenFormaat);
        $(':input[name="eigen_formaat[1]"]').keyup(orderStickers.checkEigenFormaat);
        $(':input[name="eigen_formaat[2]"]').change(orderStickers.checkEigenFormaat);

        $(".gen-block-5 .oplage-label").click(function() {
            var text = $(this).find('.oplage-aantal').text();
            $('.sidebar-item5 .sidebar-item-text').text(text);
            $('.sidebar-item5').addClass('sidebar-item-active');
        });

        $(".gen-block-6 .del-block").click(function() {
            var text = $(this).find('.del-aantal').text();
            $('.sidebar-item6 .sidebar-item-text').text(text);

            var price = $(this).find('.del-block-price').text();
            $('.sidebar-item7 .sidebar-item-price-top').text(price);

            $('.sidebar-add-inner').addClass('sidebar-add-active');

            orderStickers.deliveryType = $(this).attr('data-days');
            orderStickers.virtualPageview();

        });

        $(".gen-block-6 .del-block-list .del-block").click(function() {
            $(".gen-block-6").addClass('gen-block-active');
            $(".sidebar-item6").addClass('sidebar-item-active');
        });

        $(".del-block").click(function (e) {
            $(this).addClass('del-block-active').siblings().removeClass('del-block-active');
        });

        $(".gen-item-list .gen-item").click(function (e) {
            $(this).addClass('gen-active').siblings().removeClass('gen-active');
        });
        $('.match-height').matchHeight();
        setTimeout(function(){
            $('.match-height').matchHeight();
        }, 400);
        $('.gen-more-items a').click(function(){
            orderStickers.viewAllFormats();
            return false;
        });

        if ($('#product-detail-tekst').length > 0){
            orderStickers.productId = $('#product-detail-tekst').attr('data-id');
        }

        if ($(':input[name="eigen_formaat[0]"]').length > 0 && $(':input[name="eigen_formaat[0]"]').val().length > 0){
            $(':input[name="eigen_formaat[0]"]').keyup();
        }
    }
};